@if (text) {
  {{ text }}
} @else {
  <ng-container *ngTemplateOutlet="contentTemplate; context: getContext()"></ng-container>
}
